// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { Utils } from '../../../shared';
import { LanguagesBaseService } from './languages-base.service';
import { Constants, LanguageModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class LanguagesMockService extends LanguagesBaseService {

  constructor() {
    super();
  }

  initialiseLanguage(selectedLocale: string | undefined): void {
    this.languages$.subscribe(langs => {
      const selectedLanguage = langs.find(l => {
        const translateLanguageAndCulture = this._getLocale(l);
        return translateLanguageAndCulture === selectedLocale;
      });
      if (!Utils.isUndefined(selectedLanguage) && !Utils.isNull(selectedLanguage)) {
        this._selectedLanguage$.next(selectedLanguage as LanguageModel);
      }
    });
  }

  loadLanguages(): void {
    let languages = new Array<LanguageModel>();

    languages = [
      Constants.DEFAULT_LANGUAGE,
      {
        id: 2,
        name: 'English - USA',
        nativeName: '\'merican',
        isoTwoLetterName: 'en',
        isoTwoLetterCode: 'en',
        isoThreeLetterName: 'USA',
        cultureCode: 'US',
        isRtl: false
      }
    ];

    this._languages$.next(languages);
  }

  updateUserLanguage(userLanguage: LanguageModel): void {}
}
